import React from "react";

import AssessmentStatusNotAvailable from "../assessment/AssessmentStatusNotAvailable";
import AssessmentStatusIcon from "../assessment/AssessmentStatusIcon";

const MESSAGES = {
    ASSESSMENT_DATA_UNAVAILABLE: "Performer marking unavailable.",
    ASSESSMENT_PENDING: "Performer marking still pending."
};

export default function FlagDisplay({isChecked, isPassed, tags}) {

    const isAssessmentDataNotAvailable = isChecked === undefined || isChecked === null;
    const isAssessmentPendingToBeSubmitted = !isChecked && !isAssessmentDataNotAvailable;

    return <>
        {isAssessmentDataNotAvailable && <AssessmentStatusNotAvailable label={MESSAGES.ASSESSMENT_DATA_UNAVAILABLE}/>}

        {isAssessmentPendingToBeSubmitted && <AssessmentStatusNotAvailable label={MESSAGES.ASSESSMENT_PENDING}/>}

        {isChecked && <AssessmentStatusIcon isPassed={isPassed} tags={tags}/>}
    </>;
}